module.exports = __webpack_public_path__ + "static/img/img-sreen02.baf4ccf.jpg";